<template>
  <el-switch
    class="r-switch"
    v-model="value"
    @change="change($event)"
  ></el-switch>
</template>

<script>
export default {
  props: ["readonly", "emitter", "ikey", "type", "state", "getData", "putData"],
  data() {
    return {
      value: true
    };
  },
  watch: {
    "state.data.switch": {
      handler: function(val) {
        this.value = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    change(value) {
      this.state.data.switch = value;
      this.update();
    },
    update() {
      if (this.ikey) this.putData(this.ikey, this.value);
      this.emitter.trigger("process");
    }
  },
  created() {
    if (this.getData(this.ikey) !== undefined) {
      this.value = this.getData(this.ikey);
    } else {
      this.update();
    }
  }
};
</script>

<style lang="scss" scoped>
.r-switch {
  width: 30px !important;
  position: absolute !important;
  top: 28px;
  right: 8px;
  z-index: 10;
  .el-switch__core {
    transition: none !important;
    background-color: var(--dividers_low_contrast) !important;
    border-color: var(--dividers_low_contrast) !important;
  }
  &.is-checked {
    .el-switch__core {
      border-color: var(--dividers_low_contrast) !important;
    }
  }
}
</style>
